import { CimaMembershipTypeCard } from 'components/molecules/CimaMembershipTypeCard/CimaMembershipTypeCard';
import { MembershipTypes } from 'mxp-schemas';
import React, { useCallback } from 'react';
import { Grid, SemanticWIDTHS } from 'semantic-ui-react';
import styled from 'styled-components';
import { getModalData } from 'utils';

interface Props {
  productList: any;
  selectPathway: (pathway: string) => void;
  pathwayExemptions?: any;
  pathway?: string;
  offlineExemptionsEntryLevels?: State.Membership['offlineExemptionsEntryLevels'];
}

export const ExemptionPathwaySelector: React.FC<Props> = ({
  productList,
  selectPathway,
  pathwayExemptions,
  pathway,
  offlineExemptionsEntryLevels,
}) => {
  const removeDuplicateCards = useCallback((data: any, key: any) => {
    return [...new Map(data?.map((level: any) => [key(level), level]))?.values()];
  }, []);

  const nameConversion = useCallback((value: any) => {
    return Number(value?.substring(6)) || '';
  }, []);
  return (
    <StyledContentWrapper>
      <Grid stackable columns={productList?.length > 3 ? 4 : (productList?.length as SemanticWIDTHS)}>
        {productList?.map((product: any) => {
          const exemptionInfo = pathwayExemptions[product?.slug];

          const isApprenticeship = product?.slug === MembershipTypes.CIMALearningPathwaySlug.APPRENTICESHIP;

          const filteredLowerLevel = removeDuplicateCards(
            exemptionInfo?.lowerExemptionLevelRef,
            (level: any) => level.name
          );
          const tempModalData = getModalData(
            filteredLowerLevel,
            product?.slug === MembershipTypes.CIMALearningPathwaySlug.FLP
          );

          const entryPointModalDataList = [...tempModalData].sort((a, b) => (a.cardIndex > b.cardIndex ? 1 : -1));

          const convertedName = nameConversion(exemptionInfo?.name);

          // Logic for pulling the short descriptions from the offlineExemptionsEntryLevels that is derived from Contentful
          const foundEntryLevel = offlineExemptionsEntryLevels?.find(
            ({ pathwaySlug }) =>
              product?.slug.includes(pathwaySlug?.toLowerCase()) ||
              (product?.slug === MembershipTypes.CIMALearningPathwaySlug.APPRENTICESHIP &&
                pathwaySlug === MembershipTypes.Pathway.PQ)
          );
          const description = (foundEntryLevel as any)?.[`exemptionLevel${convertedName}ShortDescription`] || '';

          return (
            <Grid.Column key={product.name}>
              <CimaMembershipTypeCard
                {...product}
                isEntryPointLevel={true}
                selectMembership={selectPathway}
                modalHeader={`Your exemptions for ${product?.name}`}
                modalDescription="Based on the information you provided (professional body, professional and educational experience), the following experience(s) have gained your exemptions"
                entryPointDataList={entryPointModalDataList}
                entryPoint={{
                  headerTitle: convertedName,
                  description,
                }}
                exemptionInfo={exemptionInfo}
                isApprenticeshipCard={isApprenticeship}
                isCardSelected={pathway === product?.slug}
                isOfflineExemptionCalculator={true}
                selectPathway={selectPathway}
              />
            </Grid.Column>
          );
        })}
      </Grid>
      <br />
    </StyledContentWrapper>
  );
};

const StyledContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > .ui.grid > .row {
    gap: ${props => props.theme.pxToRem(20)};
    flex-wrap: nowrap;

    ${props => props.theme.mediaQueries.mobileOnly} {
      flex-direction: column;
    }
  }

  > .ui.stackable.grid > .column.row > .column,
  > .ui.stackable.grid > .column.row > .column {
    ${props => props.theme.mediaQueries.mobileOnly} {
      padding: 0 !important;
    }
  }

  .column.flex-column {
    display: flex !important;
    padding: 0 !important;
    z-index: 1;
  }

  .row.flex-row {
    z-index: 0;
  }

  .ui.stackable.grid > .row > .column {
    ${props => props.theme.mediaQueries.mobileOnly} {
      padding: 0 !important;
    }
  }
`;
